import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { useSession } from './session'

/**
 * Garde de route.
 *
 * CE N'EST PAS UNE SECURITE. C'EST DU CONFORT D'AFFICHAGE.
 *
 * Tout ce qui est dans `src/` est livre au navigateur : cette redirection se
 * contourne en editant l'etat de l'application depuis la console, ou en
 * appelant l'API directement sans jamais charger la page. La securite reelle,
 * la seule, c'est la RLS : un utilisateur inactif ne lit rien, un non-admin ne
 * lit pas les autres profils, et personne ne supprime un dossier.
 *
 * Autrement dit : une route atteinte par contournement ne doit JAMAIS constituer
 * une faille — elle doit seulement afficher une page vide. Les tests 13 et 12 de
 * bout en bout prouvent l'un et l'autre, dans cet ordre d'importance.
 */
export function GardeRoute({
  children,
  adminRequis = false,
}: {
  children: ReactNode
  adminRequis?: boolean
}) {
  const etat = useSession()
  const emplacement = useLocation()

  if (etat.statut === 'chargement') {
    return (
      <p className="p-8 text-slate-600" role="status">
        Chargement…
      </p>
    )
  }

  if (etat.statut === 'deconnecte') {
    // `from` permet de revenir a la page demandee apres la connexion.
    return <Navigate to="/connexion" replace state={{ from: emplacement.pathname }} />
  }

  if (adminRequis && etat.profil.role !== 'admin') {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
